import { useDebouncedCallback, useIsWindowBiggerThan } from '@bob/library'
import { shallowCompare } from '@websrc/App/Helpers/shallowCompare'
import { RefObject, useEffect, useRef, useState } from 'react'

import { BOTTOM_SPACING, FixedWrapperProps } from './LessonStudentMaterial.style'

export function useFixedScroll(
  wrapperRef: RefObject<HTMLDivElement>,
  contentRef: RefObject<HTMLDivElement>,
  topCompensation = 0
) {
  const [wrapperProps, setWrapperProps] = useState<FixedWrapperProps>({
    position: 'relative',
    width: 0,
    left: 0,
    top: 0,
  })

  const isDesktopRef = useRef(false)
  const isDesktop = useIsWindowBiggerThan(1023)

  useEffect(() => {
    isDesktopRef.current = isDesktop
  })

  function check() {
    if (wrapperRef.current && contentRef.current) {
      const wrapperRect = wrapperRef.current.getBoundingClientRect()
      const sidebarRect = wrapperRef.current.parentElement?.getBoundingClientRect()
      const contentHeight = contentRef.current.getBoundingClientRect().height

      const newProps: FixedWrapperProps = {
        position: 'relative',
        width: 0,
        left: 0,
        top: 0,
      }

      if (isDesktopRef.current) {
        if (wrapperRect.top < topCompensation) {
          newProps.position = 'fixed'
          newProps.left = wrapperRect.left
          newProps.top = topCompensation
          newProps.width = wrapperRect.width
        }

        if (
          sidebarRect &&
          topCompensation + contentHeight > sidebarRect.top + sidebarRect.height - BOTTOM_SPACING
        ) {
          newProps.position = 'absolute'
          newProps.left = 0
          newProps.top = 0
          newProps.width = wrapperRect.width
        }
      }

      if (!shallowCompare(newProps, wrapperProps)) {
        setWrapperProps(newProps)
      }
    }
  }

  const bouncedCheck = useDebouncedCallback(() => check(), 100)

  useEffect(() => {
    document.addEventListener('scroll', check, true)
    window.addEventListener('resize', bouncedCheck)

    return () => {
      document.removeEventListener('scroll', check, true)
      window.removeEventListener('resize', bouncedCheck)
    }
  })

  return wrapperProps
}
